import { get, post } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const metaService = {
    /**
     * Get Meta (Facebook/Instagram) OAuth authorization URL
     */
    getAuthorizationUrl: async () => {
        try {
            const response = await get(API_ENDPOINTS.CRM.META.AUTHORIZE);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    authorizationUrl: response.data.authorizationUrl
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to get authorization URL'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to get authorization URL'
            };
        }
    },

    /**
     * Sync Meta leads
     */
    syncLeads: async () => {
        try {
            const response = await post(API_ENDPOINTS.CRM.META.SYNC);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    ...response.data
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to sync Meta leads'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to sync Meta leads'
            };
        }
    },

    /**
     * Get Meta integration status
     */
    getIntegrationStatus: async () => {
        try {
            const response = await get(API_ENDPOINTS.CRM.META.STATUS);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    ...response.data
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to get integration status'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to get integration status'
            };
        }
    },

    /**
     * Disconnect Meta integration
     */
    disconnect: async () => {
        try {
            const response = await post(API_ENDPOINTS.CRM.META.DISCONNECT);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    message: response.responseMessage || 'Meta disconnected successfully'
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to disconnect Meta'
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to disconnect Meta'
            };
        }
    }
};

export default metaService;
